import {
  TRACK_CONFIGS as SHARED_TRACK_CONFIGS,
  type TrackConfig as SharedTrackConfig,
} from '@cars/shared';
import type { TrackConfig } from '../types';
import { TRACK_SCENE_MANIFESTS } from './trackScenes';

type Presentation = Omit<TrackConfig, keyof SharedTrackConfig>;

const PRESENTATION: Record<number, Presentation> = {
  1: {
    bottomPath: '/assets/Appearance/Appearance1_bottom.png',
    topPath: '/assets/Appearance/Appearance1_top.png',
    landscapePath: '/assets/Landscape/Landscape1.png',
    checkpointPath: '/assets/Checkpoints/Checkpoints1.png',
    minimapPath: '/assets/Minimaps/Minimap1.png',
    minimapX: 12,
    minimapY: 392,
  },
  2: {
    bottomPath: '/assets/Appearance/Appearance2.png',
    topPath: '/assets/Appearance/Appearance2_top.png',
    landscapePath: '/assets/Landscape/Landscape2.png',
    checkpointPath: '/assets/Checkpoints/Checkpoints2.png',
    minimapPath: '/assets/Minimaps/Minimap2.png',
    minimapX: 12,
    minimapY: 362,
  },
  3: {
    bottomPath: '/assets/Appearance/Appearance3_bottom.png',
    topPath: '/assets/Appearance/Appearance3_top.png',
    landscapePath: '/assets/Landscape/Landscape3.png',
    checkpointPath: '/assets/Checkpoints/Checkpoints3.png',
    minimapPath: '/assets/Minimaps/Minimap3.png',
    minimapX: 12,
    minimapY: 362,
  },
  4: {
    bottomPath: '/assets/Appearance/Appearance4_bottom.png',
    topPath: '/assets/Appearance/Appearance4_top.png',
    landscapePath: '/assets/Landscape/Landscape4.png',
    checkpointPath: '/assets/Checkpoints/Checkpoints4.png',
    minimapPath: '/assets/Minimaps/Minimap4.png',
    minimapX: 12,
    minimapY: 362,
  },
};

export const TRACK_CONFIGS: Record<number, TrackConfig> = Object.fromEntries(
  Object.entries(SHARED_TRACK_CONFIGS).map(([id, config]) => [
    id,
    {
      ...config,
      ...PRESENTATION[Number(id)],
      visualManifestPath: TRACK_SCENE_MANIFESTS[Number(id)],
    },
  ]),
) as Record<number, TrackConfig>;
